<template>
  <div class="container">
    <h1>{{ title }}</h1>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: ['code'],
  computed: {
    title() {
      switch (parseInt(this.code)) {
        case 400:
          return '400 - Solicitud incorrecta';
        case 403:
          return '403 - Acceso denegado';
        case 404:
          return '404 - Página no encontrada';
        case 500:
          return '500 - Error interno del servidor';
        default:
          return `${this.code} - Error desconocido`;
      }
    },
    message() {
      switch (parseInt(this.code)) {
        case 400:
          return 'La solicitud no pudo ser procesada debido a un error del cliente.';
        case 403:
          return 'No tienes permisos para acceder a esta página.';
        case 404:
          return 'La página que buscas no existe o ha sido movida.';
        case 500:
          return 'Ocurrió un error inesperado en el servidor. Comunicarse con el administrador.';
        default:
          return 'Se ha producido un error inesperado. Comunicarse con el administrador.';
      }
    }
  }
};
</script>

<style scoped>
.container {
  font-family: Arial, sans-serif;
  text-align: center;
  padding: 5rem;
}
h1 {
  font-size: 3rem;
  color: #c00;
}
p {
  font-size: 1.2rem;
  margin-top: 1rem;
}
</style>
